export function hasPurchasedExertionRecovery(data, activityId) {
  return !!data?.entitlements?.oneOff?.reports?.[activityId]?.exertionRecovery;
}

export function getLastFreeLungFitnessAt(data) {
  const ts = data?.freebies?.lungFitness?.grantedAt;
  return ts ? (ts.seconds ? ts.seconds * 1000 : ts) : null;
}

export function canGrantLungFitnessFreebieNow(data) {
  const last = getLastFreeLungFitnessAt(data);
  if (!last) return true;
  const THIRTY_DAYS = 30 * 24 * 60 * 60 * 1000;
  return Date.now() - last >= THIRTY_DAYS;
}
